// Default menu settings configurations

export interface MenuItem {
  title: string;
  icon: string;
  page: string;
  isExternalLink?: boolean;
  issupportExternalLink?: boolean;
  badge: { type: string, value: string };
  submenu: {
    items: Partial<MenuItem>[];
  };
  section: string;
}

export interface MenuConfig {
  horizontal_menu: {
    items: Partial<MenuItem>[]
  };
  vertical_menu: {
    items: Partial<MenuItem>[]
  };
}

export const MenuSettingsConfig: MenuConfig = {
  horizontal_menu: {
    items: [
      {
        title: 'Ana Sayfa',
        icon: 'la-file',
        page: '/dashboard',
       
      },
      {
        title: 'Raporlar',
        icon: 'la-television',
        page: '/dashboard',
       
      },
      {
        title: 'Hammaddeler',
        icon: 'la-support',
        page: '/dashboard',
      },
      {
        title: 'Bileşikler',
        icon: 'la-text-height',
        page: '/compound',

      }
    ]
  },
  vertical_menu: {
    items: [
      {
        title: 'Ana Sayfa',
        icon: 'la-file',
        page: '/dashboard',
       
      },
      {
        title: 'Raporlar',
        icon: 'la-television',
        page: '/report',
       
      },
     
      {
        title: 'Grupları',
        icon: 'la-cog',
        page: '/category',
      },
      {
        title: 'Bileşikler',
        icon: 'la-text-height',
        page: '/compound',

      },
      {
        title: 'Hammaddeler',
        icon: 'la-support',
        page: '/hammadde',
      }
      ,
      {
        title: 'Tanımlar',
        icon: 'la-support',
        page:'null',
        submenu: {
          items: [
          
            {
              title: 'Bileşen Özellik',
              icon: 'la-cart-plus',
              page: '/property'
            }
           ,
           {
            title: 'Allerjenler',
            icon: 'la-cart-plus',
            page: '/allergens'
          },
          {
            title: 'Fonksiyonlar',
            icon: 'la-cart-plus',
            page: '/functions'
          }
          ]
        }
      }
    ]
  }

};





